import { useReducer } from "react";

export default (transition = true) => {
  return useReducer((s) => s + 1, 0);

};
